import { render, staticRenderFns } from "./VProducts.vue?vue&type=template&id=c3beb7e4&"
import script from "./VProducts.vue?vue&type=script&lang=js&"
export * from "./VProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports